import {
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  InputLabel,
  FormControl,
  Select,
} from "@mui/material";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const FilterItems = ({
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Is Notified
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.isNotified}
            onChange={(e) => handleChangeFilter("isNotified")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Notified Date Start
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.notifiedDateStart}
            onChange={(newValue) =>
              handleChangeFilter("notifiedDateStart")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Notified Date End
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={filterData.notifiedDateEnd}
            onChange={(newValue) =>
              handleChangeFilter("notifiedDateEnd")(null, newValue)
            }
            format="DD/MM/YYYY"
            sx={{ width: "100%" }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleFilter();
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>

      <Grid item xs={12} md={4}>
        <InputLabel sx={{ fontSize: "14px", marginBottom: "5px" }}>
          Custom Template?
        </InputLabel>
        <FormControl fullWidth>
          <Select
            value={filterData.isCustomTemplate || ""}
            onChange={(e) => handleChangeFilter("isCustomTemplate")(e)}
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === "Enter") handleFilter();
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12}>
        <Box textAlign="right">
          <Button
            variant="outlined"
            onClick={handleClearFilters}
            sx={{ mr: 1, color: "#7152F3" }}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            sx={{ backgroundColor: "#7152F3" }}
          >
            Filter{" "}
            <ArrowForward fontSize="small" style={{ marginLeft: "5px" }} />
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FilterItems;
